import React from 'react';
import * as ds from './dataService';
import { StyledTextField } from 'modules/components/layer01';
import { SelectSubcontractorField } from 'modules/components/layer04';
import { FormBaseLayout } from 'modules/components/layer10';
import { Stack } from '@mui/material';


export type SaveSubcontractorTimeFormProps = {
  handleClose: () => void;
  id: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveSubcontractorTimeFormProps) => {
  const form = ds.useFormState();

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {}}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <Stack
        rowGap='1.5rem'
      >
        <SelectSubcontractorField.FC
          form={form}
          fieldName='personId'
        />
        <StyledTextField.FC
          {...form.genFieldProps('hoursLogged')}
        />
      </Stack>
    </FormBaseLayout.FC>

  );
};
